/* wl-selecteurs.js — WL-TIENT, sorti de la page le 26/08/2026 (phase 2c). Autonome : minuteries de rattrapage integrees. */
/* ===================================================================
   WL-TIENT : les textes de la fiche tiennent dans leur place
   ===================================================================
   Le meme defaut revenait partout des qu'on quittait le francais : des
   tailles fixes, calees sur des mots francais, et des textes qui debordent
   ou se coupent ailleurs. On ne corrige pas texte par texte : on mesure la
   place reellement disponible a l'ecran et on s'y adapte.

   Cinq endroits, une seule mecanique :

     A. la place que prend la pastille « ou » entre les deux cartes ;
     B. le nom et le descriptif des cartes — AUCUN MOT N'EST JAMAIS COUPE ;
     C. le libelle du bouton d'achat, sur une seule ligne ;
     D. les onglets du bloc description, en deux rangees au plus ;
     E. la plaque « exclusivite », remontee sur les formats hauts.

   Rien par langue, rien par fiche. Vrai aussi pour les langues qui ne sont
   pas encore publiees.
   =================================================================== */
(function () {
  'use strict';

  var MOBILE = '(max-width: 999px)';

  /* ---------------- la regle a mesurer ----------------
     Un element cache hors de l'ecran, habille de la meme police que ce
     qu'on mesure. On y lit la largeur d'un texte a une taille donnee sans
     jamais toucher a la page. */
  var regle = null;
  function largeur(modele, texte, taille) {
    if (!regle) {
      regle = document.createElement('span');
      regle.setAttribute('aria-hidden', 'true');
      regle.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;'
                          + 'white-space:pre;pointer-events:none;margin:0;padding:0';
      document.body.appendChild(regle);
    }
    var cs = window.getComputedStyle(modele);
    regle.style.fontFamily = cs.fontFamily;
    regle.style.fontWeight = cs.fontWeight;
    regle.style.fontStyle = cs.fontStyle;
    regle.style.letterSpacing = cs.letterSpacing;
    regle.style.textTransform = cs.textTransform;
    regle.style.fontSize = taille + 'px';
    regle.textContent = texte;
    return regle.getBoundingClientRect().width;
  }

  function dispoDe(el) {
    var cs = window.getComputedStyle(el);
    return el.clientWidth - (parseFloat(cs.paddingLeft) || 0)
                          - (parseFloat(cs.paddingRight) || 0);
  }

  /* La taille d'origine, retenue une fois pour toutes : sans elle, chaque
     passage repartirait du reglage du precedent et le texte retrecirait
     sans fin. */
  function origine(el) {
    var b = parseFloat(el.getAttribute('data-wl-base') || '');
    if (!b) {
      b = parseFloat(window.getComputedStyle(el).fontSize);
      if (!b) { return 0; }
      el.setAttribute('data-wl-base', b);
    }
    return b;
  }

  function poser(el, taille, base) {
    if (taille >= base) {
      if (el.style.fontSize) { el.style.removeProperty('font-size'); }
      return;
    }
    var v = taille.toFixed(1) + 'px';
    /* on n'ecrit que si la valeur change : c'est ce qui empeche de relancer
       la mise en page a chaque passage, donc de faire clignoter le texte */
    if (el.style.fontSize !== v) { el.style.setProperty('font-size', v, 'important'); }
  }

  /* La largeur d'un texte suit sa taille de police : un seul calcul donne
     presque la bonne valeur, sans boucle qui descend pas a pas. On verifie
     ensuite, parce que le crenage n'est pas tout a fait proportionnel. */
  function faireTenir(el, texte, dispo, plancher) {
    var b = origine(el);
    if (!b || !texte || dispo <= 10) { return; }
    var voulu = largeur(el, texte, b);
    var taille = b;
    if (voulu > dispo) {
      taille = Math.max(plancher, Math.floor(b * dispo / voulu * 10) / 10);
      var garde = 0;
      while (garde < 10 && taille > plancher && largeur(el, texte, taille) > dispo) {
        taille = Math.max(plancher, taille - 0.3);
        garde += 1;
      }
    }
    poser(el, taille, b);
  }

  function motLePlusLong(texte) {
    var mots = texte.split(' ');
    var long = '';
    for (var i = 0; i < mots.length; i++) {
      if (mots[i].length > long.length) { long = mots[i]; }
    }
    return long;
  }

  function lire(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* ============ A. la place que prend la pastille « ou » ============
     Elle est posee a cheval sur la gouttiere. Il ne faut lui reserver que
     ce qu'elle mord VRAIMENT sur chaque carte — mesure, pas devine — et
     seulement sur les elements qui sont a sa hauteur : le descriptif l'est,
     le nom ne l'est pas.

     Ma premiere version reservait la moitie de la largeur de la pastille
     sur les quatre textes a la fois. C'est ce qui a fait couper
     « contemporain » : ces textes acceptent la cesure en plein mot, et la
     marge volee suffisait a la declencher. */
  function calerPastille() {
    var bloc = document.querySelector('.wls-bloc');
    if (!bloc) { return false; }
    var p = bloc.querySelector('.wl-ou');
    if (!p) { return false; }
    var rp = p.getBoundingClientRect();
    if (!rp.width) { return false; }

    var MARGE = 5;
    var cotes = [['0', 'Right'], ['1', 'Left']];
    var travaux = [];

    for (var c = 0; c < cotes.length; c++) {
      var carte = bloc.querySelector('.wl-c[data-i="' + cotes[c][0] + '"]');
      if (!carte) { continue; }
      var rc = carte.getBoundingClientRect();
      var mord = (cotes[c][1] === 'Right') ? (rc.right - rp.left) : (rp.right - rc.left);
      mord = Math.max(0, Math.ceil(mord) + MARGE);
      var textes = carte.querySelectorAll('.nm, .ds');
      for (var i = 0; i < textes.length; i++) {
        var el = textes[i];
        var r = el.getBoundingClientRect();
        /* « a hauteur de la pastille » est retenu une fois pour toutes :
           poser la marge deplace le texte, ce qui pourrait faire changer la
           reponse au passage suivant et lancer un va-et-vient sans fin. */
        if (el.getAttribute('data-wl-ou') !== '1'
            && !(r.bottom <= rp.top || r.top >= rp.bottom)) {
          el.setAttribute('data-wl-ou', '1');
        }
        travaux.push([el, cotes[c][1], mord]);
      }
    }

    for (var j = 0; j < travaux.length; j++) {
      var e2 = travaux[j][0], cote = travaux[j][1], m = travaux[j][2];
      var prop = 'padding' + cote;
      if (e2.getAttribute('data-wl-ou') === '1' && m > 0) {
        var v = m + 'px';
        if (e2.style[prop] !== v) { e2.style[prop] = v; }
      } else if (e2.style[prop]) {
        e2.style.removeProperty(cote === 'Right' ? 'padding-right' : 'padding-left');
      }
    }
    return true;
  }

  /* ============ B. aucun mot n'est jamais coupe ============
     Ces textes portent « overflow-wrap: anywhere » : quand un mot ne tient
     pas sur sa ligne, le navigateur le casse au milieu. On mesure donc le
     mot le PLUS LONG et on reduit la police juste assez pour qu'il tienne.
     Le repli entre les mots reste permis — c'est la cesure en plein mot
     qu'on interdit. En francais rien ne bouge : rien ne depassait. */
  function calerCartes() {
    var bloc = document.querySelector('.wls-bloc');
    if (!bloc) { return false; }
    var els = bloc.querySelectorAll('.wl-c .nm, .wl-c .ds');
    if (!els.length) { return false; }
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var t = lire(el);
      if (!t) { continue; }
      faireTenir(el, motLePlusLong(t), dispoDe(el),
                 el.classList.contains('nm') ? 11 : 10);
    }
    return true;
  }

  /* ============ C. le bouton d'achat garde sa hauteur ============
     « Ajouter au panier » tient sur une ligne, le bouton fait 74 px.
     « Toevoegen aan winkelwagen » passait a deux lignes : 118 px. Le
     libelle vit dans un « div » que le theme fabrique ; on le reduit juste
     assez pour qu'il tienne sur une ligne. */
  function calerPanier() {
    var vus = document.querySelectorAll('.wl-cad');
    if (!vus.length) { return false; }
    var fait = false;
    for (var i = 0; i < vus.length; i++) {
      var lbl = null, enfants = vus[i].children;
      for (var j = 0; j < enfants.length; j++) {
        if (enfants[j].tagName === 'DIV' && lire(enfants[j])) { lbl = enfants[j]; break; }
      }
      if (!lbl) { continue; }

      /* LA HAUTEUR DU BOUTON NE DOIT PAS SUIVRE CELLE DU MOT.
         Reduire le libelle le fait tenir sur une ligne — c'est le but — mais
         le bouton maigrissait avec le mot : 74 px en francais, 66 en
         neerlandais, 59 sur un ecran de 320. On rend au libelle la hauteur
         de ligne qu'il aurait a sa taille de depart.

         Le rapport « hauteur de ligne / taille de police » ne change pas
         quand on reduit la police : une seule lecture suffit a le calculer,
         dans n'importe quelle langue et a n'importe quel moment. */
      var b0 = origine(lbl);
      if (b0) {
        var cs0 = window.getComputedStyle(lbl);
        var lh = parseFloat(cs0.lineHeight);
        var px = parseFloat(cs0.fontSize) || b0;
        if (isNaN(lh)) { lh = px * 1.2; }          /* « normal » */
        var haut = Math.round(b0 * (lh / px)) + 'px';
        if (lbl.style.minHeight !== haut) { lbl.style.minHeight = haut; }
      }

      faireTenir(lbl, lire(lbl), dispoDe(lbl), 15);
      fait = true;
    }
    return fait;
  }

  /* ============ D. les onglets en deux rangees au plus ============
     Cinq libelles traduits debordent vite sur une troisieme rangee. On
     compte les rangees par les hauteurs distinctes — la seule mesure qui
     ne suppose rien de la mise en page — et on reduit la police jusqu'a
     revenir a deux. */
  var memoOnglets = '';
  function calerOnglets() {
    var bar = document.querySelector('.wlinfo-bar');
    if (!bar) { return false; }
    var tabs = bar.querySelectorAll('.wlinfo-tab');
    if (!tabs.length) { return false; }
    var b = origine(tabs[0]);
    if (!b) { return false; }

    var empreinte = '';
    for (var k = 0; k < tabs.length; k++) { empreinte += lire(tabs[k]) + '|'; }
    empreinte += Math.round(bar.getBoundingClientRect().width);
    if (empreinte === memoOnglets) { return true; }

    function rangees() {
      var hauteurs = {}, n = 0;
      for (var i = 0; i < tabs.length; i++) {
        var h = Math.round(tabs[i].getBoundingClientRect().top);
        if (!hauteurs[h]) { hauteurs[h] = 1; n += 1; }
      }
      return n;
    }
    function habiller(v) {
      for (var i = 0; i < tabs.length; i++) { poser(tabs[i], v, origine(tabs[i]) || b); }
    }

    /* ON CHERCHE LA PLUS GRANDE TAILLE QUI TIENNE, pas la premiere venue.
       La version d'avant descendait par pas de 0,6 px et gardait le premier
       essai concluant : sur un ecran de 320 elle allait jusqu'au plancher de
       10 px alors qu'une taille bien superieure suffisait. Par dichotomie,
       cinq mesures donnent le meilleur resultat a chaque fois. */
    var PLANCHER = 10;
    habiller(b);
    if (rangees() > 2) {
      var bas = PLANCHER, haut = b, retenue = PLANCHER;
      for (var tour = 0; tour < 6 && haut - bas > 0.2; tour++) {
        var essai = (bas + haut) / 2;
        habiller(essai);
        if (rangees() <= 2) { retenue = essai; bas = essai; }
        else { haut = essai; }
      }
      habiller(retenue);
    }
    memoOnglets = empreinte;
    return true;
  }

  /* ============ E. la plaque « exclusivite » ============
     Sur mobile, et pour les formats VERTICAL et CARRE seulement, elle
     remonte de 10 % de la hauteur du cadre.

     Le cadre est en « overflow: hidden » : mesure faite, un dixieme plein
     sortirait de 9 px par le haut et la plaque serait rognee. On borne donc
     la remontee au bord du cadre.

     On agit sur « top » et non sur « transform » : la plaque entre en scene
     avec une animation qui, elle, se sert de « transform » — une animation
     l'emporte sur un style en ligne, et la plaque aurait saute a la fin de
     son entree.

     Le format n'est pas devine : le bloc selecteur le calcule a partir du
     rendu et le pose dans « data-format ». On le lit, on n'y touche pas. */
  function calerPlaque() {
    if (!window.matchMedia(MOBILE).matches) { return true; }
    var bloc = document.querySelector('.wls-bloc');
    var format = bloc && bloc.dataset ? (bloc.dataset.format || '') : '';
    if (!format) { return false; }               /* pas encore mesure */
    var plaques = document.querySelectorAll('.wl-exclu-plaque');
    if (!plaques.length) { return false; }

    var monte = (format === 'vertical' || format === 'carre');
    for (var i = 0; i < plaques.length; i++) {
      var p = plaques[i], cadre = p.parentElement;
      if (!cadre) { continue; }
      var t0 = parseFloat(p.getAttribute('data-wl-top') || '');
      if (isNaN(t0)) {
        t0 = parseFloat(window.getComputedStyle(p).top);
        if (isNaN(t0)) { continue; }
        p.setAttribute('data-wl-top', t0);
      }
      if (!monte) {
        if (p.style.top) { p.style.removeProperty('top'); }
        continue;
      }
      var h = cadre.getBoundingClientRect().height;
      if (!h) { continue; }
      var v = Math.max(2, Math.round(t0 - h * 0.10)) + 'px';
      if (p.style.top !== v) { p.style.top = v; }
    }
    return true;
  }

  /* ============ F. la loupe de la galerie ============
     Sur mobile, et pour les formats CARRES seulement, elle descend de 10 %
     de la hauteur du cadre.

     Elle est ancree EN BAS, pas en haut : la feuille mobile lui pose
     « top: auto !important ; bottom: 16px !important ». On agit donc sur
     « bottom » — un « top » en ligne ne bougeait rien, mesure faite — et on
     ecrit en « important », sinon la feuille l'emporte.

     Un dixieme plein fait 38 px : la loupe passerait de 547-587 a 585-625
     alors que la galerie s'arrete a 603 et que les vignettes commencent a
     623. Elle sortirait de 22 px sous l'image et mordrait sur les vignettes.
     On borne donc la descente au bord bas du cadre : elle descend au ras de
     l'oeuvre, et pas plus loin. */
  function calerLoupe() {
    if (!window.matchMedia(MOBILE).matches) { return true; }
    var bloc = document.querySelector('.wls-bloc');
    var format = bloc && bloc.dataset ? (bloc.dataset.format || '') : '';
    if (!format) { return false; }               /* pas encore mesure */
    var loupes = document.querySelectorAll('.product-gallery__zoom');
    if (!loupes.length) { return false; }

    var baisse = (format === 'carre');
    var vue = false;
    for (var i = 0; i < loupes.length; i++) {
      var l = loupes[i];
      /* la galerie en porte une par vue, dont plusieurs sont masquees sur
         telephone : on ne touche qu'a celle qui s'affiche vraiment */
      if (!l.getBoundingClientRect().height) { continue; }
      vue = true;
      if (!baisse) {
        if (l.style.bottom) { l.style.removeProperty('bottom'); }
        continue;
      }
      var cadre = l.parentElement;
      if (!cadre) { continue; }
      var b0 = parseFloat(l.getAttribute('data-wl-bas') || '');
      if (isNaN(b0)) {
        b0 = parseFloat(window.getComputedStyle(l).bottom);
        if (isNaN(b0)) { continue; }
        l.setAttribute('data-wl-bas', b0);
      }
      var h = cadre.getBoundingClientRect().height;
      if (!h) { continue; }
      var v = Math.max(0, Math.round(b0 - h * 0.10)) + 'px';
      if (l.style.bottom !== v) { l.style.setProperty('bottom', v, 'important'); }
    }
    return vue;
  }

  /* ---------------- quand passer ----------------
     WL-TIENT cesse de travailler une fois son travail fini.

     La premiere version observait TOUTE la page, chaque changement de
     classe compris : animations, carrousels, traceurs — chaque frisson
     relancait les six taches, et chaque tache relit des geometries. C'est
     une part des « ajustements forces de la mise en page » que PageSpeed
     signalait. Desormais : une tache finie n'est plus relancee, et quand
     les six ont fini, l'observateur est DEBRANCHE. Seul un
     redimensionnement — la rotation du telephone — remet les compteurs a
     zero, parce que c'est le seul moment ou les mesures changent. */
  var TACHES = [calerPastille, calerCartes, calerPanier, calerOnglets,
                calerPlaque, calerLoupe];
  var FAITES = [];
  var guetteur = null;

  function passer() {
    var reste = 0;
    for (var i = 0; i < TACHES.length; i++) {
      if (FAITES[i]) { continue; }
      try { FAITES[i] = TACHES[i](); } catch (err) { /* une tache qui echoue n'arrete pas les autres */ }
      if (!FAITES[i]) { reste += 1; }
    }
    if (!reste && guetteur) { guetteur.disconnect(); guetteur = null; }
  }

  var enAttente = null;
  function bientot() {
    if (enAttente) { window.clearTimeout(enAttente); }
    enAttente = window.setTimeout(function () {
      enAttente = null;
      /* tout le bloc selecteur est SOUS la ligne de flottaison : ses
         mesures attendent un moment calme au lieu de concourir avec la
         peinture du premier ecran */
      if ('requestIdleCallback' in window) {
        requestIdleCallback(passer, { timeout: 1500 });
      } else {
        passer();
      }
    }, 80);
  }

  function brancherGuetteur() {
    if (guetteur || !window.MutationObserver) { return; }
    guetteur = new MutationObserver(bientot);
    guetteur.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-format']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bientot);
  } else {
    bientot();
  }
  /* les polices arrivent apres : toutes les largeurs changent une fois
     chargees, et il faut refaire les comptes */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { FAITES = []; bientot(); });
  }
  window.addEventListener('resize', function () { FAITES = []; brancherGuetteur(); bientot(); });
  window.addEventListener('load', bientot);
  /* le format de l'oeuvre et la plaque arrivent apres l'analyse de l'image */
  brancherGuetteur();
  /* deux rattrapages, pour les rendus tardifs */
  window.setTimeout(passer, 900);
  window.setTimeout(passer, 2500);
})();
